import type { ButtonProps } from 'antd';
import { Button } from 'antd';
import type { ButtonSemanticAllType } from 'antd/es/button/Button';
import clx from 'classnames';
import React from 'react';

import type { AnalyticsEvent } from 'config/analytics';
import useAnalytics from 'config/analytics';

import { mobileIconStyle } from './style';

export type FBButtonProps = ButtonProps & {
  mobileIcon?: boolean;
  analytics?: AnalyticsEvent;
  classNames?: ButtonSemanticAllType['classNames']
}

const FBButton = React.forwardRef<HTMLButtonElement, FBButtonProps>(
  ({ analytics, classNames, icon, mobileIcon, ...rest }, buttonRef) => {
    const { onClick } = useAnalytics();
    const iconFallback = typeof icon === 'string' ? <span className={icon} /> : icon;

    return (
      <Button
        {...rest}
        ref={buttonRef}
        icon={iconFallback}
        onClick={
          analytics
            ? onClick(analytics, rest.onClick)
            : rest.onClick
        }
        classNames={{
          ...classNames,
          icon: clx('d-flex text-base', classNames?.icon),
          root: clx({ [mobileIconStyle]: mobileIcon }, classNames?.root),
        }}
      />
    );
  },
);

export default FBButton;
